import {mapActions, mapGetters} from 'vuex';
import subjectTypes from '@/core/Utils/subject-types'

export const ClassroomMixins = {
  computed: {
    ...mapGetters({
      classroom: 'ClassroomModule/getClassroomData',
      loadingClassroom: 'ClassroomModule/isLoadingClassroom',
      creatingClassroom: 'ClassroomModule/creatingClassroom',
    }),
    isWorldLanguage() {
      const selectedSubject = this.subjects.find(subject => subject.id === this.classroom.subject_id)
      return selectedSubject !== undefined && selectedSubject.type === 'world_languages'
    },
    isClassroomIndependentNonBasic() {
      const independentTypes = [
        subjectTypes.independentLanguage.type,
        subjectTypes.independentPlayersTrust.type,
      ]
      return independentTypes.includes(this.classroom?.subject?.type)
    }
  },
  methods: {
    ...mapActions({
      getClassroom: 'ClassroomModule/getClassroom',
      createClassroom: 'ClassroomModule/createClassroom',
      updateClassroom: 'ClassroomModule/updateClassroom',
      initClassroom: 'ClassroomModule/initClassroom',
      setCourseId: 'ClassroomModule/setCourseId',
      getSubject: 'ClassroomModule/getSubject',
      setCourse: 'ClassroomModule/addCourseContent',
      setPlayersTrust: 'MiscModule/setPlayersTrust',
      getClassroomNoOverlay: 'ClassroomModule/getClassroomNoOverlay'
    })
  },
};
